import React, { useState } from 'react';
import styled from 'theme/styled';
import p from 'translation';
import FileInput from 'components/form/file-input';
import { Typography } from '@mui/material';
import CropProfilePictureDialog from '../crop-profile-picture-dialog';

interface Props {
  onSelect: (image: Blob) => Promise<void>;
  canEdit: boolean;
  children: React.ReactNode;
}

export default function EditProfilePicture({
  canEdit,
  children,
  onSelect,
}: Props): JSX.Element {
  const [unprocessedImage, setUnprocessedImage] = useState<File | undefined>(
    undefined,
  );

  return (
    <>
      <CropProfilePictureDialog
        open={!!unprocessedImage}
        unprocessedImage={unprocessedImage}
        onSelect={async image => {
          await onSelect(image);
          setUnprocessedImage(undefined);
        }}
        onCancel={() => setUnprocessedImage(undefined)}
      />

      <Wrapper>
        <div className='profile-picture-container'>{children}</div>
        {canEdit && (
          <FileInput
            id='profile-image'
            type='image'
            accept='image/png, image/jpeg'
            value={unprocessedImage}
            onFile={image => {
              setUnprocessedImage(image);
            }}
            uploadMessage={
              <Typography variant='body2'>
                {p.t('pages.people.my-profile.upload-picture')}
              </Typography>
            }
            hideFileList
          />
        )}
      </Wrapper>
    </>
  );
}

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 1rem;

  .zone {
    background-color: transparent;
    padding: 1rem;
  }
`;
